<mat-card class="file-gallery-card">
  <mat-card-title>Bilder und Dokumente</mat-card-title>
  <div class="file-gallery" cdkDropList (cdkDropListDropped)="drop($event)">
    <!-- Bereits hochgeladene Dateien -->
    <div *ngFor="let file of files" cdkDrag class="file-item">
      <mat-card class="file-thumbnail">
        <img *ngIf="file.type === 'image'" [src]="file.url" alt="{{ file.name }}" class="thumbnail-image" />
        <div *ngIf="file.type === 'pdf'" class="pdf-thumbnail">
          <span class="pdf-icon">📄</span>
          <a [href]="file.url" target="_blank">{{ file.name }}</a>
        </div>
      </mat-card>
    </div>

    <!-- Upload-Button als Thumbnail -->
    <div class="file-item upload-button" (click)="openUploadDialog()">
      <mat-card class="file-thumbnail upload-thumbnail">
        <mat-icon class="upload-icon">add</mat-icon>
      </mat-card>
    </div>
  </div>
</mat-card>
